import { Address } from '../interfaces/address.interface';

const ADDRESS_TEXT_FIELDS: readonly ('Street1' | 'City' | 'State' | 'PostalCode')[] = ['Street1', 'City', 'State', 'PostalCode'];

/**
 * Whether `addressFormat` would print anything for this address. A persisted row still carries its
 * Id and sync fields when every address field is blank, so "any value set" is the wrong emptiness test.
 */
export function hasPrintableAddress(address: Partial<Address> | null | undefined): boolean {
  if (!address) return false;
  if (ADDRESS_TEXT_FIELDS.some(field => String(address[field] ?? '').trim().length > 0)) return true;
  return address.Latitude != null && address.Longitude != null;
}
